module.exports = __webpack_public_path__ + "static/media/Swalot_gaussian2.5373121e.png";